import React from "react";
import { Row } from "antd";
import { ProgrssBox } from "../../../core";
import Svg from "../../../assets/icons/icon";

const Statistics = ({ contractType }) => {
  console.log("contractType", contractType);
  // let company_id = localStorage.getItem("company_id");
  // const dispatch = useDispatch();
  // React.useEffect(() => {
  //   dispatch(saleRegister(company_id));
  // }, [company_id, dispatch]);
  // const yarnHistory = useSelector((state) => state.yarnIssence.yarnHistory);

  // const bag_received = yarnHistory
  //   .filter((yarn_rec) => {
  //     return yarn_rec.yarn_status === "Received";
  //   })
  //   .map((items) => {
  //     return items.bags;
  //   })
  //   .reduce((acc, curr) => acc + curr, 0);
  // const cons_received = yarnHistory
  //   .filter((yarn_rec) => {
  //     return yarn_rec.yarn_status === "Received";
  //   })
  //   .map((items) => {
  //     return items.cons;
  //   })
  //   .reduce((acc, curr) => acc + curr, 0);

  // console.log("data at statistic", data);
  // const totalNetPass = useSelector((state) => state.dispatches.dispatchHistory)
  //   .filter((dispatches) => {
  //     return dispatches.contract_id === data.contract_id;
  //   })
  //   .map((dispatches) => dispatches.net_pass)
  //   .reduce((acc, curr) => acc + curr, 0);
  // const yarn_used_for_warp = FIXED_TO.multiRoundOff(
  //   data.wrap_weight,
  //   totalNetPass
  // );
  // const yarn_used_for_weft = FIXED_TO.multiRoundOff(
  //   data.weft_weight,
  //   totalNetPass
  // );
  // const total_yarn_used = FIXED_TO.addRoundOff(
  //   yarn_used_for_warp,
  //   yarn_used_for_weft
  // );
  // const converted_bags = FIXED_TO.convert_into_bags(total_yarn_used);
  // const converted_cons = FIXED_TO.convert_into_cons(total_yarn_used);
  // console.log(yarn_used_for_warp, yarn_used_for_weft);
  // console.log(total_yarn_used);
  // console.log(data.contract_id);

  // const Payment_Received = useSelector((state) => state.payments.payments)
  //   .filter((payment_items) => {
  //     return (
  //       payment_items.contract_id === data.contract_id &&
  //       payment_items.payment_option === "receive"
  //     );
  //   })
  //   .map((paymentObj) => {
  //     return parseInt(paymentObj.payment_amount);
  //   })
  //   .reduce((acc, curr) => acc + curr, 0);

  // const Invoice_payemnt_test = useSelector(
  //   (state) => state.contractReducer.invoices
  // );
  // console.log("Invoice_payemnt_test", Invoice_payemnt_test);
  // const filter_Invoice = Invoice_payemnt_test
  //   ? Invoice_payemnt_test.filter((invocie_item) => {
  //       return invocie_item.contract_id === data.contract_id;
  //     })
  //       .map((contract_item) => {
  //         return parseInt(contract_item.total_value_include_sale_tax);
  //       })
  //       .reduce((acc, curr) => acc + curr, 0)
  //   : 0;
  // console.log("filter_Invoice", filter_Invoice);

  // const Invoice_payemnt = 0;
  // const Payment_Pending = Invoice_payemnt - Payment_Received;
  // console.log(Payment_Pending);
  return (
    <Row type="flex" justify="space-around" gutter={[16, 16]}>
      {contractType === "conversion" ? (
        <>
          <ProgrssBox
            svg={<Svg width={36.21} height={69.69} icon="yarnRecieved" />}
            status="primary"
            tittle="Total Yarn received"
            value={`0/0`}
            Rs={false}
          />
          <ProgrssBox
            svg={<Svg width={36.21} height={69.69} icon="yarnRecieved" />}
            status="warnning"
            tittle="Total Yarn Used"
            value={`0/0`}
            Rs={false}
          />
        </>
      ) : null}

      <ProgrssBox
        svg={<Svg width={59} height={39} icon="money" />}
        status="success"
        tittle="Payment received"
        value={0}
      />
      <ProgrssBox
        svg={<Svg width={59} height={39} icon="money" />}
        status="danger"
        tittle="Payment pending"
        value={0}
      />
    </Row>
  );
};

export default Statistics;
